import { NotificationItem, NotificationsFilterDataItem, NotificationsFilterType } from './types';
import { CommandResult, FormApiService, QueryApiService } from 'src/common/api-service';
import axios from 'axios';
// `config` se importa directo y NO por el contenedor: `inversify-config` importa este modulo, asi
// que pedirselo cierra un ciclo. Es el mismo objeto en los dos casos, porque el contenedor lo
// registra con `toConstantValue(config)`.
import config from 'src/config/app-config';

export class UserNotificationsApiService extends QueryApiService<NotificationItem> {
  constructor() {
    super('notifications');
  }
}

export class UserNotificationsFiltersApiService {
  protected _apiBaseUrl: string;

  constructor(version: string = 'v1') {
    const baseUrl = config.baseUrl;
    this._apiBaseUrl = `${baseUrl}/api/${version}/notifications`;
  }

  public async getFilterData(type: NotificationsFilterType): Promise<NotificationsFilterDataItem[]> {
    try {
      const parts: string[] = [`type=${type}`, '$format=application/json;odata.metadata=none'];
      let qs = '';

      if (parts.length > 0) {
        qs = parts.join('&');
        if (!qs.startsWith('?')) qs = '?' + qs;
      }

      const result = await axios.get<NotificationsFilterDataItem[]>(`${this._apiBaseUrl}/GetFilterData${qs}`);

      return result?.data;
    } catch {
      return [];
    }
  }
}

export class UserNotificationsFormApiService extends FormApiService {
  constructor() {
    super('notifications');
  }

  public async markAsSeen(notificationIds?: string[]): Promise<CommandResult> {
    return await this.post<{ notificationIds?: string[] }, CommandResult>({ notificationIds }, 'MarkAllAsSeen');
  }
}
